import { render, staticRenderFns } from "./SetupCast.vue?vue&type=template&id=5214b2d9&scoped=true&"
import script from "./SetupCast.vue?vue&type=script&lang=js&"
export * from "./SetupCast.vue?vue&type=script&lang=js&"
import style0 from "./SetupCast.vue?vue&type=style&index=0&id=5214b2d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5214b2d9",
  null
  
)

export default component.exports